jQuery(document).ready(function ($) {
    function dismissNotice($notice) {
        var id = $notice.data('unique-id');
        if (!id) {
            return;
        }

        $.post(thhaAdminNotice.ajaxurl, {
            action: 'thha_dismiss_notice',
            unique_id: id,
            _wpnonce: thhaAdminNotice.nonce
        });
    }

    $(document).on('click', '.thha-notice-dismiss', function () {
        var $notice = $(this).closest('.thha-admin-notice');
        $notice.fadeOut();
        dismissNotice($notice);
    });

    $('.thha-admin-notice[data-autoclose="1"]').each(function () {
        var $notice = $(this);
        var seconds = parseInt($notice.data('autoclose-after'), 10);
        if (!seconds || Number.isNaN(seconds)) {
            seconds = 20;
        }

        setTimeout(function () {
            $notice.fadeOut();
            dismissNotice($notice);
        }, seconds * 1000);
    });
});